import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { navigateToRoot } from 'app/store/common-effects/router.effects';
import { updateWebhook } from 'app/store/root/webhooks/webhooks.actions';
import { oneWebhook } from 'app/store/root/webhooks/webhooks.selectors';
import { selectFirst, to404PageIfNotFound } from 'core/utils/rx-common';
import { Uuid } from 'shared/common/types';

@Component({
  selector: 'app-update-webhook',
  templateUrl: './update-webhook.component.html',
  styleUrls: ['./update-webhook.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UpdateWebhookComponent implements OnInit {
  readonly webhookId: Uuid = this.route.snapshot.params.webhookId;
  private _webhookForm = new UntypedFormGroup({
    url: this.fb.control(null),
    retries: this.fb.array([]),
    isActivated: this.fb.control(false),
  });

  get webhookForm(): UntypedFormGroup {
    return this._webhookForm;
  }

  get retries(): UntypedFormArray {
    return this.webhookForm.controls.retries as UntypedFormArray;
  }

  constructor(
    public fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private store$: Store,
  ) { }

  ngOnInit(): void {
    this.store$.pipe(
      selectFirst(oneWebhook, { id: this.webhookId }),
      to404PageIfNotFound(this.store$, 'root'),
    ).subscribe((data) => {
      this._webhookForm = this.fb.group({
        url: this.fb.control(data.url),
        retries: this.fb.array(data.retries),
        isActivated: this.fb.control(data.isActivated),
      });
    });
  }

  updateWebhook(): void {
    this.store$.dispatch(updateWebhook({ id: this.webhookId, input: this.webhookForm.value }));
  }

  addInterval(): void {
    this.retries.push(this.fb.control(5));
  }

  removeInterval(): void {
    this.retries.removeAt(this.retries.length - 1);
  }

  goBack(): void {
    this.store$.dispatch(navigateToRoot({ path: ['integration', 'webhooks'] }));
  }
}
